export enum LoadingActionsTypes {
  LOADING = "LOADING",
  FILLING = "FILLING",
  PROCESS = "PROCESS"
}